<div class="{{ class }}">
  <!-- Fill the code -->
  <mat-error *ngIf="failedToSubmit" class="mat-error">
    {{ errorMessage }}
    <a
      class="link whitespace-nowrap ml-2"
      aria-label="forgot password"
      (click)="sendCode()">
      {{ 'validationCode:resendCode' | translate }}
    </a>
  </mat-error>
  <form
    [formGroup]="form"
    class="flex flex-col h-full mt-5"
    *ngIf="!failedToSubmit">
    <div class="flex justify-around py-5">
      <input
        type="tel"
        #txt1
        maxlength="1"
        (keyup)="move($event, null, txt1, txt2)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'one'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
      <input
        type="tel"
        #txt2
        maxlength="1"
        (keyup)="move($event, txt1, txt2, txt3)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'two'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
      <input
        type="tel"
        #txt3
        maxlength="1"
        (keyup)="move($event, txt2, txt3, txt4)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'three'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
      <input
        type="tel"
        #txt4
        maxlength="1"
        (keyup)="move($event, txt3, txt4, txt5)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'four'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
      <input
        type="tel"
        #txt5
        maxlength="1"
        (keyup)="move($event, txt4, txt5, txt6)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'five'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
      <input
        type="tel"
        #txt6
        maxlength="1"
        (keyup)="move($event, txt5, txt6, null)"
        (paste)="paste($event)"
        pattern="[0-9]"
        [formControlName]="'six'"
        class="xs:w-16 w-20 h-20 bg-accent-200 text-center text-primary text-5xl font-medium focus:shadow-xl" />
    </div>

    <caption class="flex justify-center gap-1 mb-5">
      {{
        'validationCode:didntGetTheCode' | translate
      }}
      <a
        class="link whitespace-nowrap ml-2"
        aria-label="forgot password"
        (click)="sendCode()">
        {{ 'validationCode:resendCode' | translate }}
      </a>
    </caption>

    <div class="flex justify-center">
      <mat-progress-spinner
        *ngIf="hasSubmitted"
        [diameter]="24"
        [mode]="'indeterminate'"></mat-progress-spinner>
    </div>

    <!-- Submit button -->
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="!form.valid || hasSubmitted"
      (click)="validate()">
      <span *ngIf="!form.disabled">
        {{
          (type === 'PAYOUT'
            ? 'validationCode:sendPayout'
            : type === 'WITHDRAWAL'
            ? 'validationCode:sendWithdraw'
            : 'shared:send'
          ) | translate
        }}
      </span>
      <mat-progress-spinner
        *ngIf="form.disabled"
        [diameter]="24"
        [mode]="'indeterminate'"></mat-progress-spinner>
    </button>
  </form>
</div>
